import type { FreightStatus } from "@/types/freight";
import type { Repayment, RepaymentDisplayStatus } from "@/types/repayment";

/**
 * Status do frete em que o pagamento do SALDO (BALANCE) está liberado.
 * O saldo só pode ser pago após a confirmação do recebimento do canhoto.
 */
const RELEASED_FREIGHT_STATUSES: readonly FreightStatus[] = [
  "PROOF_RECEIVED",
  "COMPLETED",
];

/** Motivo exibido na UI quando o saldo está bloqueado. */
export const BALANCE_BLOCKED_REASON =
  "Saldo bloqueado — aguardando a confirmação do recebimento do canhoto da entrega.";

type RepaymentLike = Pick<Repayment, "type" | "status" | "freight">;

/**
 * Indica se o repasse de SALDO está bloqueado para pagamento por ainda não ter
 * o canhoto confirmado. Adiantamentos nunca são bloqueados.
 */
export function isBalanceBlocked(repayment: RepaymentLike): boolean {
  return (
    repayment.type === "BALANCE" &&
    repayment.status === "PENDING" &&
    !RELEASED_FREIGHT_STATUSES.includes(repayment.freight.status)
  );
}

/**
 * Status exibido na UI. Diferente do `status` armazenado, inclui o estado
 * calculado em runtime "BLOCKED" (padrão do OVERDUE — ADR-009).
 */
export function getRepaymentDisplayStatus(
  repayment: RepaymentLike,
): RepaymentDisplayStatus {
  if (repayment.status === "PAID") return "PAID";
  if (isBalanceBlocked(repayment)) return "BLOCKED";
  return "PENDING";
}
